
(function () {
  'use strict';

  // Only load messages on startseite (index.html) and filetransfer page
  const shouldLoadMessages = window.location.pathname === '/secure/user/index.html' || 
                             window.location.pathname === '/secure/user/filetransfer.html'

  const user = JSON.parse(localStorage.getItem("user"))
  
  $(document).ready(function () {

    // Load messages only on startseite and filetransfer page
    if (shouldLoadMessages && window.location.pathname === '/secure/user/filetransfer.html') {
      const currentYear = new Date().getFullYear()
      const validYears = ['2026', '2025', '2024', '2023', '2022', '2021', '99']
      const savedTab = localStorage.getItem('filetransferLastTab')
      let initialYear
      if (savedTab && validYears.includes(savedTab) && $('#tab-' + savedTab).length) {
        initialYear = savedTab
      } else if ($('#tab-' + currentYear).length) {
        initialYear = String(currentYear)
      } else {
        initialYear = validYears[0]
      }

      function isArchiveView () {
        return $('#btnMessagesArchive').hasClass('active')
      }

      /** Jahres-Tabs: Grün wenn Archiv-Ansicht aktiv (CSS .filetransfer-archive-mode auf #filetransfer-years). */
      function syncFiletransferArchiveVisualMode () {
        $('#filetransfer-years').toggleClass('filetransfer-archive-mode', isArchiveView())
      }

      function loadMessagesForYear (year, messageLimit) {
        const limit = (messageLimit != null) ? messageLimit : 500
        const archived = isArchiveView()
        return getAktMessages(year, 'all', limit, 0, undefined, archived, true)
      }

      loadMessagesForYear(initialYear, 99).then(function (messages) {
        $('#filetransferYearsTab .nav-link').removeClass('active')
        $('#tab-' + initialYear).addClass('active')
        $('#filetransferYearsTabContent .tab-pane').removeClass('show active')
        $('#tab-pane-' + initialYear).addClass('show active')
        $('#messagesTableBody' + initialYear).html(messages)
      }).catch(function (err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
          return
        }
        console.warn('Error loading messages:', err)
      })

      $('#btnMessagesActive, #btnMessagesArchive').on('click', function (e) {
        e.preventDefault()
        $('#filetransferArchiveToggle button').removeClass('active')
        $(this).addClass('active')
        syncFiletransferArchiveVisualMode()
        const year = $('#filetransferYearsTab .nav-link.active').attr('data-year') || initialYear
        loadMessagesForYear(year, 500).then(function (messages) {
          $('#messagesTableBody' + year).html(messages)
        }).catch(function (err) {
          if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
            return
          }
          console.warn('Error loading messages (archive toggle):', err)
        })
      })

      syncFiletransferArchiveVisualMode()

      function reloadCurrentYearMessages () {
        const year = $('#filetransferYearsTab .nav-link.active').attr('data-year') || initialYear
        return loadMessagesForYear(year, 500).then(function (messages) {
          $('#messagesTableBody' + year).html(messages)
        })
      }

      $(document).on('click', '.link-message-archive', function (e) {
        e.preventDefault()
        const $a = $(this)
        if ($a.data('busy')) {
          return
        }
        const id = $a.data('message-id')
        if (!id || typeof patchMessageArchive !== 'function') {
          return
        }
        $a.data('busy', true).addClass('disabled')
        patchMessageArchive(String(id), true).then(function () {
          return reloadCurrentYearMessages()
        }).catch(function (err) {
          if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
            return
          }
          const msg = (err && err.message) ? err.message : 'Archivieren fehlgeschlagen.'
          if (typeof makeAlertBox === 'function') {
            makeAlertBox(ALERT_TYPES.DANGER, 5000, msg, '#filetransferAlert')
          } else {
            console.warn(msg)
          }
        }).always(function () {
          $a.data('busy', false).removeClass('disabled')
        })
      })

      $(document).on('click', '.link-message-restore', function (e) {
        e.preventDefault()
        const $a = $(this)
        if ($a.data('busy')) {
          return
        }
        const id = $a.data('message-id')
        if (!id || typeof patchMessageArchive !== 'function') {
          return
        }
        $a.data('busy', true).addClass('disabled')
        patchMessageArchive(String(id), false).then(function () {
          return reloadCurrentYearMessages()
        }).catch(function (err) {
          if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
            return
          }
          const msg = (err && err.message) ? err.message : 'Wiederherstellen fehlgeschlagen.'
          if (typeof makeAlertBox === 'function') {
            makeAlertBox(ALERT_TYPES.DANGER, 5000, msg, '#filetransferAlert')
          } else {
            console.warn(msg)
          }
        }).always(function () {
          $a.data('busy', false).removeClass('disabled')
        })
      })
    }

    // Message detail button handler is now in shared.js (global)

    // Handle download link clicks to prevent automatic API calls (global - needed on all pages)
    $(document).on('click', '.download-link', function(e) {
      e.preventDefault()
      // Try to get URL from data-url attribute first, then from href
      const downloadUrl = $(this).data('url') || $(this).attr('href')
      
      if (!downloadUrl) {
        return false
      }
      window.open(downloadUrl, '_blank')
    })

    // Handle file upload form validation (global - needed on all pages)
    $(document).on('uploadMessage:validated', function (event, payload) {
      
      event.preventDefault()

      const $errorContainer = $('#uploadFileError')

      if (!payload) {
        $errorContainer.removeClass('d-none').text('Das Formular ist leer. Bitte überprüfen Sie Ihre Eingaben.')
        setTimeout(function () {
          $errorContainer.addClass('d-none');
        }, 4000);
        return
      }

      $('#uploadMessageButton').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Senden...')

      const {
        type,
        year,
        subject,
        documentType,
        messageHtml,
        messageText,
        files,
        fileTitles,
        fileDocumentTypes,
        parentMessageId,
        form
      } = payload

      const formElement = form && form.length ? form[0] : document.getElementById('uploadMessageForm')

      const sendRequest = (fileData) => {

        const basePayload = {
          messageyear: year || undefined,
          messagetype: type,
          messagesubject: subject,
          message: typeof messageHtml !== 'undefined' ? messageHtml : messageText,
          messageplain: messageText,
          parentmessageid: parentMessageId || undefined
        }

        // Wenn Dateien vorhanden sind, verwende FormData für multipart/form-data
        const fileList = Array.isArray(fileData) ? fileData : (fileData ? [fileData] : [])
        if (fileList.length > 0) {
          const formData = new FormData()
          
          // Alle Basis-Felder hinzufügen
          Object.keys(basePayload).forEach(key => {
            const value = basePayload[key]
            if (value !== undefined && value !== null) {
              formData.append(key, value)
            }
          })
          
          // Datei-Felder hinzufügen (1–5 Dateien, API 0.8.2)
          const titles = Array.isArray(fileTitles) ? fileTitles : []
          const docTypes = Array.isArray(fileDocumentTypes) ? fileDocumentTypes : []
          const makeUniqueFilename = (name, idx) => {
            const ts = Date.now() + idx
            const n = (name && typeof name === 'string') ? name.trim() : ''
            if (!n) return ts + '-Dokument'
            const lastDot = n.lastIndexOf('.')
            const base = lastDot > 0 ? n.slice(0, lastDot) : n
            const ext = lastDot > 0 ? n.slice(lastDot) : ''
            return ts + '-' + base + ext
          }
          fileList.forEach((file, idx) => {
            const uniqueName = makeUniqueFilename(file.name || '', idx)
            const fileToSend = new File([file], uniqueName, { type: file.type })
            formData.append('messagefile', fileToSend)
            formData.append('messagefilename', uniqueName)
            // Titel für jede Datei (leer = Backend nutzt Dateiname)
            const title = titles[idx]
            const titleVal = (title !== undefined && title !== null && String(title).trim() !== '') ? String(title).trim() : ''
            formData.append('messagefiletitle', titleVal)
            // Dokumententyp pro Datei (Fallback: einzelner documentType)
            const docType = docTypes[idx] || documentType || ''
            formData.append('messagefiletype', docType)
          })
          
          return createMessage(formData)
        }
        
        // Ohne Datei: normales JSON
        return createMessage(basePayload)
      }

      const handleSuccess = function () {
        if ($errorContainer.length) {
          $errorContainer.addClass('d-none').text('')
        }

        if (typeof tinymce !== 'undefined') {
          const editorInstance = tinymce.get('messageBody')
          if (editorInstance) {
            editorInstance.setContent('')
          }
        }

        if (formElement) {
          formElement.reset()
        }
        $(document).trigger('uploadForm:reset')

        const $messageTypeSelect = $('#messageType')
        if ($messageTypeSelect.length) {
          $messageTypeSelect.trigger('change')
        }

        $('#uploadMessageButton').prop('disabled', false).html('Senden')
        
        // Zeige Erfolgsmeldung im Modal
        const $uploadFileError = $('#uploadFileError')
        if ($uploadFileError.length) {
          $uploadFileError
            .removeClass('d-none alert-danger')
            .addClass('alert-success')
            .html('<i class="fa fa-check-circle"></i> Vorgang wurde erfolgreich erstellt.')
        }
        
        // Schließe Modal nach kurzer Verzögerung
        setTimeout(function() {
          // Verstecke Erfolgsmeldung und setze styling zurück
          if ($uploadFileError.length) {
            $uploadFileError.addClass('d-none').removeClass('alert-success').addClass('alert-danger').empty()
          }
          
          $('#uploadModal').modal('hide')
        }, 1500)

      }

      const handleError = function (err) {

        $('#uploadMessageButton').prop('disabled', false).html('Senden')

        // Handle auth errors (401/403) if handleAuthError is available
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#filetransferAlert')) {
          return // Will redirect to login
        }

        const errorMessage = err && err.message ? err.message : 'Senden fehlgeschlagen.'

        if ($errorContainer.length) {
          $errorContainer.removeClass('d-none').text(errorMessage)
        } else {
          makeAlertBox(ALERT_TYPES.DANGER, 4000, errorMessage, '#filetransferAlert')
        }
      }

      if (files && files.length > 0) {
        sendRequest(files).then(handleSuccess).catch(handleError)
      } else {
        sendRequest().then(handleSuccess).catch(handleError)
      }

    })

    // Handle file transfer years tab clicks (only on filetransfer page)
    if (window.location.pathname === '/secure/user/filetransfer.html') {
      $(document).on('click', '#filetransferYearsTab button', function (event) {
        event.preventDefault()
        const year = $(this).attr('data-year')
        localStorage.setItem('filetransferLastTab', year)

        // Aktiviere den Tab manuell, um sicherzugehen
        $('#filetransferYearsTab .nav-link').removeClass('active');
        $(this).addClass('active');
        $('#filetransferYearsTabContent .tab-pane').removeClass('show active');
        $('#tab-pane-' + year).addClass('show active');

        const archived = $('#btnMessagesArchive').hasClass('active')
        getAktMessages(year, 'all', 500, 0, undefined, archived, true).then(function (messages) {
          $('#messagesTableBody' + year).html(messages)
        }).catch(function (err) {
          if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
            return
          }
          console.warn('Error loading messages for year ' + year + ':', err)
          $('#messagesTableBody' + year).html('<p class="text-danger text-center">Fehler beim Laden der Nachrichten</p>')
        })
      })
    }
    
  }) 
  
})();

function createMessage (data) {
  const ajaxOptions = {
    method: 'POST',
    url: '/cockpit/createmessage',
    global: false // Prevent global error handler
  }

  // Wenn FormData, dann multipart/form-data verwenden
  if (data instanceof FormData) {
    ajaxOptions.data = data
    ajaxOptions.processData = false
    ajaxOptions.contentType = false
  } else {
    // Normales JSON
    ajaxOptions.data = JSON.stringify(data)
    ajaxOptions.contentType = 'application/json; charset=UTF-8'
    ajaxOptions.processData = false
  }

  return $.ajax(ajaxOptions)
    .then(function (result) {
      if (result && result.error !== undefined) {
        return Promise.reject(new Error(result.error))
      }
      return result
    })
    .catch(function (err) {
      // Pass through auth errors (401/403) with status intact
      if (err && (err.status === 401 || err.status === 403)) {
        return Promise.reject(err) // Keep original error with status
      }
      // Handle other errors
      if (err && err.responseJSON && err.responseJSON.error) {
        return Promise.reject(new Error(err.responseJSON.error))
      }
      const statusText = err && (err.statusText || err.message)
      return Promise.reject(new Error(statusText || 'Unbekannter Fehler beim Senden der Nachricht'))
    })
}

function displayMessageDetails(details) {
  const content = $('#messageDetailContent')
  
  // Validate that we have details
  if (!details) {
    content.html('<p class="text-muted">Keine Details verfügbar</p>')
    return
  }
  let html = '<div class="message-detail">'
  // Subject
  if (details.subject) {
    html += '<h5 class="mb-3">' + escapeHtml(details.subject) + '</h5>'
  }
  // Date
  if (details.date) {
    html += '<p class="text-muted mb-2"><small><i class="fa fa-calendar"></i> ' + escapeHtml(details.date) + '</small></p>'
  }
  // Type
  if (details.type) {
    html += '<p class="mb-2"><strong>Typ:</strong> ' + escapeHtml(details.type) + '</p>'
  }
  // Message/Content
  if (details.message) {
    html += '<div class="message-body border-top pt-3 mt-3">' + escapeHtml(details.message) + '</div>'
  } else if (details.content) {
    html += '<div class="message-body border-top pt-3 mt-3">' + escapeHtml(details.content) + '</div>'
  }
  html += '</div>'
  
  content.html(html)
}

// Helper function to escape HTML to prevent XSS
function escapeHtml(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }
  return text.replace(/[&<>"']/g, function(m) { return map[m]; })
}
